var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BuildingSelect',{ref:"address_select",attrs:{"shipping":_vm.order.shipping,"client_id":_vm.order.client_id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }